import t from "./index261.js";
import { createElementBlock as e, openBlock as n, renderSlot as r } from "vue";
import a from "./index231.js";
const c = ["data-component"];
function s(o, p, l, d, m, i) {
  return n(), e("div", {
    "data-component": o.$options.name,
    class: "px-4 font-bold text-white rounded-tl-normal text-caption bg-color-neutral-black/50"
  }, [
    r(o.$slots, "default")
  ], 8, c);
}
const $ = /* @__PURE__ */ a(t, [["render", s]]);
export {
  $ as default
};
